import { render, staticRenderFns } from "./ItemSetting.vue?vue&type=template&id=df480014&scoped=true"
import script from "./ItemSetting.vue?vue&type=script&lang=js"
export * from "./ItemSetting.vue?vue&type=script&lang=js"
import style0 from "./ItemSetting.vue?vue&type=style&index=0&id=df480014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df480014",
  null
  
)

export default component.exports